<br/><br/>
<img style="background-color: rgba(255, 255, 255, 0.6)" src="../../../assets/images/flowcharts/action_flowchart.png"/>
